import React from "react";
import PropTypes from "prop-types";
import Framework from "@beardeddevops/react.framework";
import Select from "react-select";
import classNames from 'classnames';
import {isEqual} from "lodash";

export default class CollectionOverride extends Framework.Components.Collection {
	static propTypes = {
		...super.propTypes,
		scannedCode: PropTypes.any,
		locations: PropTypes.array.isRequired,
		states: PropTypes.array.isRequired,
		kiosks: PropTypes.array,
		account: PropTypes.string,
	};

	constructor(props, model) {
		super(props, model);
		this.state.unarchivedLocations = this.filterArchivedLocations();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		super.componentDidUpdate(prevProps, prevState, snapshot);

		const {locations} = this.props;
		if (!isEqual(locations, prevProps.locations)) {
			this.setState({
				unarchivedLocations: this.filterArchivedLocations()
			});
		}

		if ((this.props.scannedCode === null && this.state.searched !== null) || (this.props.scannedCode && this.state.searched !== this.props.scannedCode.barcode)) {
			this.setState({
				search: this.props.scannedCode ? this.props.scannedCode.barcode : this.state.search,
				searched: this.props.scannedCode ? this.props.scannedCode.barcode : null,
			});
		}
	}

	customStyles = {
		menu: (provided) => ({
			...provided, zIndex: 9999
		})
	};

	/** @param {Locations_Properties} option */
	filterLocationOptions = (option) => !option.archived;

	filterArchivedLocations = () => {
		/** @type {Array.<Locations_Object>} locations */
		const locations = this.props.locations;
		return locations
			.filter(location => !location.archived)
			.map(location => { return {value: location.binary_id + '-' + location.pkey, label: location.name_display || location.name}})
	}

	renderLocationFilter() {
		const {unarchivedLocations, filter, filterLocation} = this.state;
		return (
			<div className="locationFilter">
				<Select
					styles={this.customStyles}
					className={classNames('basic-single', {hasSelection: filter.location != null && filter.location.length})}
					classNamePrefix="select"
					onChange={this.doFilter}
					value={filterLocation}
					isClearable={true}
					isSearchable={true}
					name="location"
					placeholder={"Locations..."}
					isMulti
					options={unarchivedLocations}
				/>
			</div>
		);
	}

	renderStateFilter() {
		const {filter, filterState} = this.state;
		return (
			<div className="statusFilter">
				<Select
					styles={this.customStyles}
					className={classNames('basic-single', {hasSelection: filter.state != null && filter.state.length})}
					classNamePrefix="select"
					onChange={this.doFilter}
					value={filterState}
					isClearable={true}
					isSearchable={true}
					name="state"
					placeholder={"State..."}
					options={[{"value":"AL","label":"Alabama","helper":""},{"value":"AK","label":"Alaska","helper":""},{"value":"AS","label":"American Samoa","helper":""},{"value":"AZ","label":"Arizona","helper":""},{"value":"AR","label":"Arkansas","helper":""},{"value":"AE","label":"Armed Forces Africa","helper":""},{"value":"AA","label":"Armed Forces Americas","helper":""},{"value":"AE","label":"Armed Forces Canada","helper":""},{"value":"AE","label":"Armed Forces Europe","helper":""},{"value":"AE","label":"Armed Forces Middle East","helper":""},{"value":"AP","label":"Armed Forces Pacific","helper":""},{"value":"CA","label":"California","helper":""},{"value":"CO","label":"Colorado","helper":""},{"value":"CT","label":"Connecticut","helper":""},{"value":"DE","label":"Delaware","helper":""},{"value":"DC","label":"District of Columbia","helper":""},{"value":"FM","label":"Federated States of Micronesia","helper":""},{"value":"FL","label":"Florida","helper":""},{"value":"GA","label":"Georgia","helper":""},{"value":"GU","label":"Guam","helper":""},{"value":"HI","label":"Hawaii","helper":""},{"value":"ID","label":"Idaho","helper":""},{"value":"IL","label":"Illinois","helper":""},{"value":"IN","label":"Indiana","helper":""},{"value":"IA","label":"Iowa","helper":""},{"value":"KS","label":"Kansas","helper":""},{"value":"KY","label":"Kentucky","helper":""},{"value":"LA","label":"Louisiana","helper":""},{"value":"ME","label":"Maine","helper":""},{"value":"MH","label":"Marshall Islands","helper":""},{"value":"MD","label":"Maryland","helper":""},{"value":"MA","label":"Massachusetts","helper":""},{"value":"MI","label":"Michigan","helper":""},{"value":"MN","label":"Minnesota","helper":""},{"value":"MS","label":"Mississippi","helper":""},{"value":"MO","label":"Missouri","helper":""},{"value":"MT","label":"Montana","helper":""},{"value":"NE","label":"Nebraska","helper":""},{"value":"NV","label":"Nevada","helper":""},{"value":"NH","label":"New Hampshire","helper":""},{"value":"NJ","label":"New Jersey","helper":""},{"value":"NM","label":"New Mexico","helper":""},{"value":"NY","label":"New York","helper":""},{"value":"NC","label":"North Carolina","helper":""},{"value":"ND","label":"North Dakota","helper":""},{"value":"MP","label":"Northern Mariana Islands","helper":""},{"value":"OH","label":"Ohio","helper":""},{"value":"OK","label":"Oklahoma","helper":""},{"value":"OR","label":"Oregon","helper":""},{"value":"PW","label":"Palau","helper":""},{"value":"PA","label":"Pennsylvania","helper":""},{"value":"PR","label":"Puerto Rico","helper":""},{"value":"RI","label":"Rhode Island","helper":""},{"value":"SC","label":"South Carolina","helper":""},{"value":"SD","label":"South Dakota","helper":""},{"value":"TN","label":"Tennessee","helper":""},{"value":"TX","label":"Texas","helper":""},{"value":"UT","label":"Utah","helper":""},{"value":"VT","label":"Vermont","helper":""},{"value":"VI","label":"Virgin Islands","helper":""},{"value":"VA","label":"Virginia","helper":""},{"value":"WA","label":"Washington","helper":""},{"value":"WV","label":"West Virginia","helper":""},{"value":"WI","label":"Wisconsin","helper":""},{"value":"WY","label":"Wyoming","helper":""}]}
				/>
			</div>
		);
	}

	renderStatusFilter() {
		const {filter, filterStatus} = this.state;
		return (
			<div className="statusFilter">
				<Select
					styles={this.customStyles}
					className={classNames('basic-single', {hasSelection: filter.status != null && filter.status.length})}
					classNamePrefix="select"
					onChange={this.doFilter}
					value={filterStatus}
					isClearable={true}
					isSearchable={true}
					name="status"
					placeholder={"Status..."}
					options={[
						{value: null, label: 'Open and Closed Entries'},
						{value: 1, label: 'Open Entries Only'},
						{value: 2, label: 'Closed Entries Only'},
					]}
				/>
			</div>
		);
	}

	renderSearchFields(columns) {
		const {searchField} = this.state;

		let columnsToSearch = columns
			// Flatten array if there are subheaders present
			.map((col) => {
				return col.columns ? col.columns : col;
			})
			.flat()
			.filter(col => {
				return (typeof col.show === 'undefined' || col.show)
					&& col.className !== 'button-cell'
					&& col.accessor != null;
			})
			.map(c => {
				return {value: c.id||c.accessor, label: c.Header}
			});

		return (
			<div className="statusFilter">
				<Select
					styles={this.customStyles}
					// className={classNames('basic-single', {hasSelection: filter.status != null && filter.status.length})}
					classNamePrefix="select"
					onChange={this.doSearchField}
					value={searchField}
					// isClearable={true}
					isSearchable={true}
					name="field"
					placeholder={"Field to search..."}
					options={columnsToSearch}
				/>
			</div>
		);
	}

	render() {
		return super.render();
	}
}
